<template>
  <section id="main-container"  style="background-color: rgb(230, 230, 230);">
    <v-container fluid>
      <v-layout flex>
        <v-flex xs12 style="max-width:1020px;margin:0 auto;">
          <div id="centered-content">
            <img
              height="160px"
              style="margin:0 auto; display:block; padding-bottom:40px; "
              slot="activator"
              src="../assets/login-cb-logo.svg"
            />

            <v-layout
              wrap
              row
              &#x3C;v-layout
              :style="$vuetify.breakpoint.mdAndUp && 'min-height:350px;'"
            >
              <v-flex
                xs12
                md6
                class="login-box pa-4"
                style="border-top-right-radius: 5px;border-bottom-right-radius: 0px; border-bottom-left-radius: 0px;border-top-left-radius: 5px;'"
                :style="$vuetify.breakpoint.mdAndUp && 'border-top-right-radius: 0px;border-bottom-right-radius: 0px; border-bottom-left-radius: 5px;border-top-left-radius: 5px;'"
              >
                <v-flex style="display:table; height:100%; width:100%;" class="pa-4">
                  <div style="display:table-cell; vertical-align:middle;">
                    <h1 class="primary--text pb-3">Create a new password</h1>
                    <v-form ref="form"  @keyup.native.enter="resetSubmit">
                      <v-text-field
                        box
                        label="Password"
                        v-model="password"
                        :append-icon="showPass ? 'visibility_off' : 'visibility'"
                        :type="showPass ? 'text' : 'password'"
                        @click:append="showPass = !showPass"
                        min="6"
                        required
                        class="mb-0"
                      ></v-text-field>
                      <v-text-field
                        box
                        label="Re-type Password"
                        v-model="confirmPassword"
                        :append-icon="showPass ? 'visibility_off' : 'visibility'"
                        :type="showPass ? 'text' : 'password'"
                        @click:append="showPass = !showPass"
                        min="6"
                        required
                        class="mb-0"
                      ></v-text-field>

                      <div id="reset-feedback" :class="feedbackClass" v-if="passwordMismatch"><p>Please ensure the passwords match.</p></div>

                      <v-flex pt-0>
                        <router-link :to="{ name: 'Login'}">
                          <v-btn
                            block
                            class="ml-0 mb-2 mt-0"
                            color="secondary"
                            :style="$vuetify.breakpoint.mdAndUp && 'width:calc(50% - 10px); float:left; margin-right:20px; margin-bottom:0px !important'"
                          >Back to Login</v-btn>
                        </router-link>
                        <v-btn
                          block
                          class="ml-0 mb-0 mt-0"
                          color="tertiary"
                          @click="resetSubmit"
                          :style="$vuetify.breakpoint.mdAndUp && 'width:calc(50% - 10px)'"
                        >Confirm</v-btn>
                      </v-flex>

                      <v-alert
                        id="submit-feedback"
                        :value="showValidationMessage"
                        :type="flashSeverity"
                        class="mb-3"
                      >{{ validationMessage }}</v-alert>                      
                    </v-form>
                  </div>
                </v-flex>
              </v-flex>
              <v-flex
                xs12
                md6
                class="promo-box pa-4"
                style="border-top-right-radius: 0px;border-bottom-right-radius: 5px; border-bottom-left-radius: 5px;border-top-left-radius: 0px;'"
                :style="$vuetify.breakpoint.mdAndUp && 'border-top-right-radius: 5px;border-bottom-right-radius: 5px; border-bottom-left-radius: 0px;border-top-left-radius: 0px;'"
              >
                <v-flex style="display:table; height:100%;width:100%;" class="pa-4">
                  <div style="display:table-cell; vertical-align:middle;">
                    <h2 class="pb-2" style="line-height:1.2em;">
                      Explore the latest new
                      features in Caseblocks
                    </h2>
                    <p>
                      We’ve been busy developing and expanding Caseblocks
                      core functionalilty to make it even better.
                    </p>
                    <v-btn class="ml-0 mt-1" color="secondary" outline>Explore</v-btn>
                  </div>
                </v-flex>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "ResetPassword",
  components: {},
  data: () => {
    return {
      password: "",
      confirmPassword: "",
      showPass: false,
      feedbackClass: "feedback-fail",
    }
  },
  computed: {
    passwordMismatch() {
      return this.password!=="" && this.confirmPassword!=="" && this.password !== this.confirmPassword
    },
    showValidationMessage() {
      return !!this.validationMessage
    },
    validationMessage() {
      return this.flashMessage ? this.flashMessage.message : undefined
    },
    flashSeverity() {
      if (this.flashMessage && this.flashMessage.severity === "success") {
        return "success"
      }
      if (this.flashMessage && this.flashMessage.severity === "warning") {
        return "warning"
      }
      return "error"
    },
    ...mapState({
      flashMessage: state => state.ui.flashMessage
    })
  },
  methods: {
    resetSubmit() {
      if (!this.passwordMismatch) {
        const m = window.location.href.match(/token=(.*)$/)
        if (m) {
          const token = m[1]
          console.log({token})
          this.$store.dispatch("resetPassword", {password: this.password, token} )        
        }
      }
    }
  }
}
</script>
